export default '/build/ac78d0f3.svg'